import {
  CommonEntitiesListResponse,
  SaasAdminCreationDto,
  SaasAdminUpdateDto,
} from '@docbay/schemas';
import axiosInstance from './axiosInstance';

/**
 * API for managing internal users.
 */
export const InternalUsersAPI = {
  /**
   * Fetches a list of internal users based on the given parameters.
   *
   * @param params - The query parameters to be used in the request.
   * @returns A promise that resolves with the response from the server.
   */
  fetchInternalUsers: (params: any) =>
    axiosInstance.get<CommonEntitiesListResponse<any>>(
      '/saas/users-management/internal-users',
      {
        params,
      },
    ),

  /**
   * Creates a new internal user with the given data.
   *
   * @param data - The data for the new user to be created.
   * @returns A promise that resolves with the response from the server.
   */
  createInternalUser: (data: SaasAdminCreationDto) =>
    axiosInstance.post('/saas/create-admin', data),

  /**
   * Edits an existing internal user with the given ID and updated data.
   *
   * @param id - The ID of the user to be edited.
   * @param data - The updated data for the user to be edited.
   * @returns A promise that resolves with the response from the server.
   */
  editInternalUser: (id: string, data: SaasAdminUpdateDto) =>
    axiosInstance.patch(`/saas/admin/${id}?adminType=${data.userType}`, data),

  /**
   * Deletes an existing internal user with the given ID and type.
   *
   * @param adminId - The ID of the user to be deleted.
   * @param type - The type of the user to be deleted.
   * @returns A promise that resolves with the response from the server.
   */
  deleteInternalUser: (adminId: string, type: string) =>
    axiosInstance.delete(`/saas/admin/${adminId}?adminType=${type}`),
};
